import React from 'react'

import { FontWeight, Text } from '@gousto-internal/citrus-react'

type RecipeCountProps = {
  count: number
}

export const RecipeCount = ({ count }: RecipeCountProps) => (
  <Text fontWeight={FontWeight.Bold} size={4}>
    {count} recipe{count === 1 ? '' : 's'}
  </Text>
)
